module.exports = __webpack_public_path__ + "img/bck3.40273370.jpg";